
class ProfilePicData{
    data: string | undefined
}

export default new ProfilePicData()